/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mission Impact Auth API
 * OpenAPI spec version: v1
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CreateInvitationRequest,
  InvitationResponse,
  ProblemDetails,
} from '../missionImpactAuthAPI.schemas';

import { instance } from '../../mutator-auth';
import type { ErrorType } from '../../mutator-auth';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Invites a user to join an organization by email. Creates a pending invitation that will be linked to the user when they sign up. The user must explicitly accept the invitation after signing up. Requires Administrator role in the organization.
 * @summary Invite user to organization
 */
export const createInvitation = (
  orgId: string,
  createInvitationRequest: CreateInvitationRequest,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<InvitationResponse>(
    {
      url: `/v1/org/${orgId}/invitations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createInvitationRequest,
      signal,
    },
    options
  );
};

export const getCreateInvitationMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvitation>>,
    TError,
    { orgId: string; data: CreateInvitationRequest },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInvitation>>,
  TError,
  { orgId: string; data: CreateInvitationRequest },
  TContext
> => {
  const mutationKey = ['createInvitation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInvitation>>,
    { orgId: string; data: CreateInvitationRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return createInvitation(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInvitation>>
>;
export type CreateInvitationMutationBody = CreateInvitationRequest;
export type CreateInvitationMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Invite user to organization
 */
export const useCreateInvitation = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createInvitation>>,
      TError,
      { orgId: string; data: CreateInvitationRequest },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createInvitation>>,
  TError,
  { orgId: string; data: CreateInvitationRequest },
  TContext
> => {
  const mutationOptions = getCreateInvitationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
